export default {
  getters: {
    GET_BALANCE: 'GET_BALANCE',
  },
  actions: {
    FETCH_BALANCE: 'FETCH_BALANCE',
  },
};
